import React from 'react';
import styled from 'styled-components';
import environment from '../constants/environment';

import { isCSR, capitalise, trackEvent } from '../helpers';

const Wrapper = styled.div`
  text-align: center;
  font-size: 0.8em;
  padding-top: 20px;
  padding-bottom: 50px;
  text-align: center;

  a {
    padding: 3px 0;
    text-decoration: none;
    transition: padding 0.1s linear;

    &:hover {
      padding-bottom: 5px;
    }
  }
`;

export default function Footer() {
  const isSSR = typeof window !== 'undefined';
  return (
    <Wrapper>
      <p>
        &copy; Copyright {new Date().getFullYear()} Say I do Wedding Planning
        Pty Ltd.
      </p>
      <small
        style={{
          fontSize: '8px',
          color: '#ccc',
          display: 'block',
          padding: '10px',
        }}
      >
        {isSSR ? 'ssr' : 'csr'}-{environment.name.slice(0, 3)}
      </small>
    </Wrapper>
  );
}
